import $ from 'jquery/src/jquery';
import SiteHeader from "../modules/site-header";

export default () => {
    const nodeSelectors = {
        container: '[js-no-ajax-load-more="container"]',
        item: '[js-no-ajax-load-more="item"]',
        loadMoreBtn: '[js-no-ajax-load-more="load-more-btn"]',
        loadMoreBtnHolder: '[js-no-ajax-load-more="load-more-btn-holder"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        $(nodeSelectors.container).each(function () {
            let container = $(this)

            let items = container.find(nodeSelectors.item)
            let btn = container.find(nodeSelectors.loadMoreBtn)
            let btnHolder = container.find(nodeSelectors.loadMoreBtnHolder)
            let perPage = container.data('js-no-ajax-load-more--per-page');

            if( items.length > perPage ) {
                items.slice(0, perPage).show();

                btnHolder.slideDown()

                btn.on('click', function (e) {
                    e.preventDefault()

                    container.find(nodeSelectors.item + ":hidden").slice(0, perPage).slideDown();

                    if ( container.find(nodeSelectors.item + ":hidden").length === 0) {
                        btnHolder.slideUp()
                    }

                    // $('html,body').animate({
                    //     scrollTop: $(this).offset().top-300
                    // }, 700);
                });
            } else {
                // $('.loadMoreTransactions').slideDown();
                btnHolder.slideUp()
            }
        })
    }

    return Object.freeze({
        init,
        // nodeSelectors
    })
}